const MEDIA = `${process.env.REACT_APP_BACKEND_URL}/api/media`;

export const ASSETS = {
  logo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_peil-design/artifacts/w0wvz710_logo.JPG",
  md: "https://customer-assets-jai6qajn.emergentagent.net/job_6894109b-142d-4f27-a342-9ca396e9dbd3/artifacts/tqgh039j_WhatsApp%20Image%202026-05-04%20at%2021.30.15.jpeg",
  group: `${MEDIA}/clean_team.jpg`,
  training: `${MEDIA}/clean_training.jpg`,
  award: `${MEDIA}/clean_award.jpg`,
  heroLeaf: "https://images.pexels.com/photos/9173499/pexels-photo-9173499.jpeg",
  meeting: "https://images.unsplash.com/photo-1577962917302-cd874c4e31d2",
  discussion: "https://images.unsplash.com/photo-1578574577315-3fbeb0cecdc2",
  tower: "https://images.pexels.com/photos/20587183/pexels-photo-20587183.jpeg",
  security: "https://images.pexels.com/photos/60504/security-protection-anti-virus-software-60504.jpeg",
};

export const GALLERY = [
  {
    src: `${MEDIA}/clean_training.jpg`,
    title: "Capacity building in session",
    caption: "Hands-on training with participants across the public and private sectors.",
  },
  {
    src: `${MEDIA}/clean_team.jpg`,
    title: "Our team & faculty",
    caption: "The consultants and facilitators behind every Peil engagement.",
  },
  {
    src: `${MEDIA}/clean_award.jpg`,
    title: "Recognising excellence",
    caption: "Celebrating participants and partners at the close of a programme.",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Vision",
    body: "To be a world-class organization in human capital development and management in Africa.",
  },
  {
    no: "02",
    title: "Mission",
    body: "To add excellent value to our clients' business as a supportive business partner in areas of human capital, competency development and management.",
  },
  {
    no: "03",
    title: "Core Ideology",
    body: "Improving the quality of life through capacity building and innovation — anchored on honesty, integrity, trust and ethics, continual self improvement, corporate social responsibility, and deep respect for individual ability and creativity.",
  },
];

export const SERVICES = [
  { n: "01", title: "Consultancy", desc: "Strategic advisory across human capital, competency and organizational development.", img: "group" },
  { n: "02", title: "Capacity Building", desc: "Superior quality training programmes delivered by advanced-level trainers.", img: "training" },
  { n: "03", title: "Business Development", desc: "Growth strategy and market development for public and private organizations.", img: "award" },
  { n: "04", title: "IT Management", desc: "Information technology management, systems and digital transformation.", img: "security" },
  { n: "05", title: "Resourcing", desc: "Recruitment, manpower planning and talent acquisition end-to-end.", img: "group" },
  { n: "06", title: "Outsourcing & Labour Supply", desc: "Managed workforce solutions and flexible labour supply.", img: "training" },
  { n: "07", title: "Industrial Security & Safety", desc: "Security and safety management for people, assets and continuity.", img: "security" },
  { n: "08", title: "Office & Security Equipment Supply", desc: "Procurement and supply of office and security equipment.", img: "tower" },
];

export const TRAINING = [
  {
    title: "Management & Leadership",
    tag: "Executive",
    courses: [
      "Strategic Leadership for Senior Executives",
      "Emotional Intelligence for Leaders",
      "Change Management & Organizational Transformation",
      "Performance Management Systems",
      "Coaching & Mentoring for Managers",
      "Effective Delegation & Team Empowerment",
      "Corporate Governance & Board Effectiveness",
      "Decision-Making & Problem Solving",
      "Leading High-Performance Teams",
      "Conflict Resolution & Negotiation Skills",
      "Talent Management & Succession Planning",
      "Strategic Human Resource Management",
      "Managing Workplace Diversity & Inclusion",
      "Executive Communication & Public Speaking",
      "Project Leadership & Delivery",
      "Finance for Non-Finance Managers",
      "Time & Priority Management for Executives",
      "Ethics & Integrity in Leadership",
      "Women in Leadership & Management",
      "Innovation & Design Thinking for Leaders",
    ],
  },
  {
    title: "Information Management",
    tag: "Systems",
    courses: [
      "Fundamentals of Information Management",
      "Data Governance & Quality Management",
      "Knowledge Management Strategies",
      "Enterprise Content Management",
      "Information Lifecycle Management",
      "Master Data Management",
      "Information Architecture & Taxonomy Design",
      "Big Data Analytics for Decision Making",
      "Business Intelligence & Reporting",
      "Information Security & Privacy Management",
      "Document & Workflow Automation",
      "Metadata Management & Classification",
      "Digital Asset Management",
      "Data Protection & Regulatory Compliance",
      "Information Governance Frameworks",
      "Cloud Information Management",
      "Data Visualization & Dashboards",
      "Managing Information Systems Projects",
      "Records & Information Management Integration",
      "Ethics in Information Handling",
    ],
  },
  {
    title: "Business Continuity Management",
    tag: "Resilience",
    courses: [
      "Introduction to Business Continuity Management",
      "Business Impact Analysis (BIA)",
      "Risk Assessment & Treatment",
      "Developing a Business Continuity Plan",
      "Disaster Recovery Planning",
      "Crisis Management & Communication",
      "Emergency Response Planning",
      "ISO 22301 Implementation",
      "Business Continuity Testing & Exercises",
      "Supply Chain Resilience",
      "IT Service Continuity Management",
      "Pandemic & Health Emergency Preparedness",
      "Incident Management & Response",
      "Continuity Strategy Development",
      "Building Organizational Resilience",
      "Business Continuity Auditing",
      "Recovery Time & Point Objectives Planning",
      "Third-Party & Vendor Risk Continuity",
      "Crisis Leadership & Decision-Making",
      "Continuity Programme Governance & Maintenance",
    ],
  },
  {
    title: "Record Management",
    tag: "Archival",
    courses: [
      "Fundamentals of Records Management",
      "Records Classification & Filing Systems",
      "Electronic Records Management (ERM)",
      "Records Retention & Disposition Scheduling",
      "Archival Management & Preservation",
      "Managing Physical Records Storage",
      "Digitization & Document Imaging",
      "Freedom of Information & Access Management",
      "Records Management Policy Development",
      "Compliance & Regulatory Recordkeeping",
      "Vital Records Protection",
      "Managing Email & Digital Correspondence",
      "Metadata for Records Management",
      "Records Auditing & Quality Control",
      "Managing Confidential & Sensitive Records",
      "Records Management for HR & Payroll",
      "Financial Records Management",
      "Migration to Records Management Systems (RMS)",
      "Managing Records Through the Lifecycle",
      "Ethics & Legal Aspects of Recordkeeping",
    ],
  },
  {
    title: "Industrial Security & Safety",
    tag: "Protection",
    courses: [
      "Occupational Health & Safety (OHS) Fundamentals",
      "Industrial Security Management",
      "Fire Safety & Prevention",
      "Hazard Identification & Risk Assessment (HIRA)",
      "Workplace Safety Auditing & Inspection",
      "Physical Security & Access Control",
      "Emergency Evacuation & Response",
      "First Aid & CPR",
      "Security Personnel Training & Supervision",
      "Safety Management Systems (ISO 45001)",
      "Personal Protective Equipment (PPE) Management",
      "Incident Investigation & Reporting",
      "Loss Prevention & Asset Protection",
      "Crowd & Event Security Management",
      "Working at Heights & Confined Spaces Safety",
      "Chemical & Hazardous Materials Handling",
      "Surveillance Systems & CCTV Operations",
      "Executive Protection & Close Guarding",
      "Behaviour-Based Safety",
      "Security Threat & Vulnerability Assessment",
    ],
  },
  {
    title: "Information Technology Management",
    tag: "Digital",
    courses: [
      "IT Governance & Strategy",
      "IT Service Management (ITIL)",
      "Cybersecurity Management",
      "Network Administration & Management",
      "Cloud Computing & Virtualization",
      "IT Project Management",
      "Database Administration & Management",
      "Enterprise Resource Planning (ERP) Systems",
      "Software Development Lifecycle Management",
      "IT Infrastructure Management",
      "Data Centre Management",
      "Digital Transformation Strategy",
      "Systems Analysis & Design",
      "IT Risk & Compliance Management",
      "Business Process Automation",
      "AI & Machine Learning Fundamentals",
      "IT Vendor & Contract Management",
      "Help Desk & Technical Support Management",
      "Web & Mobile Application Management",
      "Emerging Technologies & Innovation",
    ],
  },
];

export const WHY_DIFFERENT = [
  "Partnership with International and Local Organizations",
  "Qualified, motivated, competent and experienced professionals",
  "Regular training and exposure of staff to current industry issues",
  "Access to relevant case studies in our environment and the world at large",
];

export const WHY_PEIL = [
  "Superior quality training programmes",
  "Prompt proposal and customer service",
  "Excellent co-ordination of programmes",
  "Trainers with advanced-level competencies",
  "Competitive pricing",
  "Effective post-training follow-up",
  "Preferred business partner",
];

export const MD = {
  name: "P. O. Ajetunmobi, Esq.",
  role: "Principal Consultant / Chief Executive Officer",
  quote:
    "For over four decades, we have believed that an organization is only ever as strong as the people who build it.",
  bio: [
    "Paul O. Ajetunmobi is the Principal Consultant and Chief Executive Officer of Peil Consultancy Limited, with over 45 years of varied experience as an astute Human Resources practitioner and consultant, as well as a legal practitioner.",
    "He is an Associate Member of the Chartered Institute of Personnel Management of Nigeria (ACIPM), a member of the Nigerian Bar Association, and a full Member of the Nigerian Institute of Management (Chartered). He holds an MPA in Human Resources Management from the University of Lagos, a B.Sc. (Hons) in Sociology from Ahmadu Bello University, an LL.B (Hons) from Lagos State University, and was called to the Nigerian Bar in 2005.",
    "He spent over 33 years at the Nigerian National Petroleum Corporation across Manpower Planning & Development, Resourcing, Records & Archival Management, Compensation & Benefits, Performance and Change Management, before joining the Board of Peil Consultancy Limited as Principal Partner / CEO.",
  ],
  credentials: ["ACIPM", "MNIM (Chartered)", "Nigerian Bar", "MPA, UNILAG", "45+ Years"],
};

export const TEAM = [
  { name: "Olaniyi Olopade, SAN, PhD", role: "Senior Advocate of Nigeria", note: "Corporate & commercial law, PhD in Commercial Law (ARU, Cambridge). Highly skilled litigator." },
  { name: "Prof. Oladipupo A. Olugoke, PhD", role: "Professor of Forensic Accounting", note: "Fellow of ICAN, interdisciplinary scholar with 60+ publications; forensic auditing & governance." },
  { name: "Prof. Oyewole O. Sarumi", role: "Leadership & Strategy", note: "25+ years organizational consultant & leadership coach; former MD/CEO Boots Nigeria PLC." },
  { name: "Olajumoke H. Gbenusola", role: "Managing Partner", note: "ICAN & CITN member; 25+ years in accounting, taxation and auditing across oil & gas and banking." },
  { name: "Tokunbo Smith", role: "Managing Consultant", note: "FIIM, 30+ years in IT, information & security management for World Bank-assisted projects." },
  { name: "Oluwasuji O. Johnson", role: "Senior Consultant (FCIPM)", note: "30+ years across capacity building, human capital development and good governance." },
  { name: "Femi Onakoya, Esq.", role: "Legal Counsel", note: "LL.M, B.L; litigation and advocacy in land, energy, maritime and commercial law." },
  { name: "Oginni Adenike O. (Mrs.)", role: "Secretary / Accountant", note: "B.Sc Accountancy; pioneer staff dedicated to accountability, dedication and loyalty." },
];

export const CONTACT = {
  phones: ["01-792 5334", "01-792 5340", "Tel/Fax: 01-291 6424"],
  email: "peilconsultancyltd@gmail.com",
  offices: [
    {
      city: "Lagos",
      tag: "Head Office",
      lines: ["Suite 20, 1st Floor, Motorways Centre", "Opposite Seven-Up Nigeria Plc", "1 Motorways Avenue, Alausa, Ikeja, Lagos"],
    },
    {
      city: "Abuja",
      tag: "FCT Office",
      lines: ["1 Rubochi Close, Off Calabar Street", "Area 7, Garki", "Abuja FCT"],
    },
  ],
};

export const DIRECTORS = [
  "P. O. Ajetunmobi (CEO)",
  "Oluwapamilerinayo Ajetunmobi",
  "S. F. Ajetunmobi (Mrs)",
  "Ekundayo A. Ajetunmobi",
  "Oluwanifemi Ajetunmobi",
  "Abraham E. Ajetunmobi (Secretary)",
];

export const NAV_LINKS = [
  { label: "About", id: "manifesto" },
  { label: "Services", id: "services" },
  { label: "Leadership", id: "leadership" },
  { label: "Team", id: "team" },
  { label: "Contact", id: "contact" },
];
